import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

/**
 * Confirmación de anulación de OP (pendiente_aprobacion | generada).
 * Los textos se pueden sobreescribir para anular un lote completo.
 */
export default function ModalAnularOrdenPago({
  open,
  onClose,
  onConfirm,
  nroOp = "",
  anulando = false,
  titulo = "Anular orden de pago",
  advertencia = "Se liberarán las facturas y quedarán disponibles otra vez. ¿Continuar?",
  detalle = "Esta acción no se puede deshacer. La orden pasará a estado Anulada.",
}) {
  const [motivo, setMotivo] = useState("");

  useEffect(() => {
    if (!open) setMotivo("");
  }, [open]);

  const handleConfirmar = () => {
    onConfirm?.(String(motivo || "").trim());
  };

  return (
    <Dialog
      open={open}
      onClose={anulando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        {titulo}
        {nroOp ? ` · ${nroOp}` : ""}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {advertencia}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {detalle}
        </Typography>
        <TextField
          fullWidth
          size="small"
          label="Motivo (opcional)"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          disabled={anulando}
          multiline
          minRows={2}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={anulando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirmar}
          disabled={anulando}
          startIcon={
            anulando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {anulando ? "Anulando…" : "Anular"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
